/* eslint-disable no-underscore-dangle */
import moment from 'moment';

export const defaultTimeframeList = {
  today: {
    to: moment()._d,
    from: moment()._d,
    text: null,
    id: 'today',
  },
  thisWeek: {
    from: moment().startOf('isoWeek')._d,
    to: moment()._d,
    text: null,
    id: 'thisWeek',
  },
  previousWeek: {
    from: moment().subtract(1, 'weeks').startOf('isoWeek')._d,
    to: moment().subtract(1, 'weeks').endOf('isoWeek')._d,
    text: null,
    id: 'previousWeek',
  },
  thisMonth: {
    from: moment().startOf('month')._d,
    to: moment()._d,
    text: null,
    id: 'thisMonth',
  },
  previousMonth: {
    from: moment().subtract(1, 'months').startOf('month')._d,
    to: moment().subtract(1, 'months').endOf('month')._d,
    text: null,
    id: 'previousMonth',
  },
  last7days: {
    from: moment().subtract(6, 'days')._d,
    to: moment()._d,
    text: null,
    id: 'last7days',
  },
  last30days: {
    from: moment().subtract(29, 'days')._d,
    to: moment()._d,
    text: null,
    id: 'last30days',
  },
  last90days: {
    from: moment().subtract(89, 'days')._d,
    to: moment()._d,
    text: null,
    id: 'last90days',
  },
  lastYear: {
    from: moment().subtract(1, 'year')._d,
    to: moment()._d,
    text: null,
    id: 'lastYear',
  },
};

export default function getTimeframeList(localizeMessage) {
  return {
    today: {
      to: moment()._d,
      from: moment()._d,
      text: localizeMessage('daterange.today'),
      id: 'today',
    },
    thisWeek: {
      from: moment().startOf('isoWeek')._d,
      to: moment()._d,
      text: localizeMessage('daterange.thisWeek'),
      id: 'thisWeek',
    },
    previousWeek: {
      from: moment().subtract(1, 'weeks').startOf('isoWeek')._d,
      to: moment().subtract(1, 'weeks').endOf('isoWeek')._d,
      text: localizeMessage('daterange.previousWeek'),
      id: 'previousWeek',
    },
    thisMonth: {
      from: moment().startOf('month')._d,
      to: moment()._d,
      text: localizeMessage('daterange.thisMonth'),
      id: 'thisMonth',
    },
    previousMonth: {
      from: moment().subtract(1, 'months').startOf('month')._d,
      to: moment().subtract(1, 'months').endOf('month')._d,
      text: localizeMessage('daterange.previousMonth'),
      id: 'previousMonth',
    },
    last7days: {
      from: moment().subtract(6, 'days')._d,
      to: moment()._d,
      text: localizeMessage('daterange.last7days'),
      id: 'last7days',
    },
    last30days: {
      from: moment().subtract(29, 'days')._d,
      to: moment()._d,
      text: localizeMessage('daterange.last30days'),
      id: 'last30days',
    },
    last90days: {
      from: moment().subtract(89, 'days')._d,
      to: moment()._d,
      text: localizeMessage('daterange.last90days'),
      id: 'last90days',
    },
    lastYear: {
      from: moment().subtract(1, 'year')._d,
      to: moment()._d,
      text: localizeMessage('daterange.lastYear'),
      id: 'lastYear',
    },
  };
}
